import http from "../../../services/httpService";
import { error } from "../../common/global";
import { catchError } from "../../../utils/errorUtil";

const props = {
    adminReportingMarker: '.marker-admin-reporting',
    downloadFrame: 'download-frame',
    datepicker: '.date_range'
};

export function initAdminReporting() {
    if ($(props.adminReportingMarker).length) {

        bindRunButton();
        bindDatePickers();
    }
}

async function bindRunButton() {
    $('.run-report').off('click').on('click', async function (e) {

        catchError(async function () {

            runReport();

        });
    });
};

function bindDatePickers() {

    $(props.datepicker).bootstrapMaterialDatePicker({
        time: false,
        format: 'DD/MM/YYYY',
        weekStart: 1,
        clearButton: true,

        //ML - it's always annoyed me that you have to click 'ok' to confirm a date change. 
        //the following setting configures the datepicker to 'make' the change when you click on a day option.
        switchOnClick: true
    });

};

// Private Functions
//
async function runReport() {

    //Convert form into object that can be translated into a dictionary by the API

    var formArray = $('#report-filters-form').serializeArray();
    var filterValues = new Object();
    for (var i = 0; i < formArray.length; i++) {
        if (formArray[i].value !== null && formArray[i].value !== "") {
            if (filterValues[formArray[i].name] === undefined) {
                filterValues[formArray[i].name] = formArray[i].value;
            }
            else {
                //For multiselect lists add to a string separated with a divider
                filterValues[formArray[i].name] += "|o|" + formArray[i].value;
            }
        }
    }

    var reportId = $('#CurrentReportId').val();

    var activityTimeout = setTimeout(function () {
        $('.run-report-activity').removeClass("display-none");
        $('.run-report').attr('disabled', 'true');
    }, 300);

    let data = {
        id: reportId,
        filterValues: filterValues
    };

    const response = await callReportService(data);

    if (response.responseType === "SUCCESS") {

        clearTimeout(activityTimeout);
        $('.run-report-activity').addClass("display-none");
        $('.run-report').removeAttr('disabled');

        //Send the file output to a hidden iframe to download seemlessly
        document.getElementById(props.downloadFrame).src = '/administration/reporting/outputreport?id=' + response.reportCode;
    }
    else {

        clearTimeout(activityTimeout);
        $('.run-report-activity').addClass("display-none");
        $('.run-report').removeAttr('disabled');
    }
};

async function callReportService(data) {

    //no TRY CATCH as handled by parent
    const response = await http.get('/administration/reporting/runreport', data);
    // The response is an object with a property called 'data'. This contains the HTML.
    return response.data;
}